export default "__VITE_ASSET__3ksNH5IT__"